import React from "react";

const About=()=>{

    return(
            <div >
                <p >
                    <img src="https://media.bibomart.net/file/Banner/4-8-2023-189bea512c4.png" alt="icon"/>
                </p>
                
                <div className="text">
                    <p> Bibo được sáng lập bởi một người Mẹ của 4 đứa con, chị Trịnh Lan Phương. Chị Phương là một chuyên gia tâm
                         lý và giáo dục, có nhiều kinh nghiệm trong lĩnh vực chăm sóc sức khoẻ Mẹ &amp; Em bé. Chị đặc biệt có nhiều 
                         kinh nghiệm “chữa lành" cho trẻ tự kỷ, là diễn giả của nhiều Hội thảo và là admin của các Cộng đồng Làm Cha Mẹ lớn nhất Việt Nam. <br/>
                    <br/> Bibo ra đời vào năm 2006, xuất phát từ các Cộng đồng phụ nữ hàng triệu thành viên như Webtretho, Lamchame ... 
                    Khi đó, với vai trò là admin của cộng đồng và chuyên gia tư vấn, chị Phương thường xuyên tổ chức các buổi offline hàng tuần 
                    cho các thành viên của Cộng đồng giao lưu và chia sẻ kinh nghiệm mang thai, nuôi dạy con cái... Bên lề các buổi hội thảo, Ba Mẹ
                     tham gia offline cũng có nhu cầu mua sắm các vật dụng cần thiết cho con mình, Bibo hình thành từ đó.
                    </p>
                </div>
                
                <p >
                    <img src="https://media.bibomart.net/file/Banner/4-8-2023-189beac0660.png" alt="icon"/>
                </p>
                <p>Chị Trịnh Lan Phương - Người sáng lập Bibo Mart</p>
                <div></div>
                <p >
                    <img src="https://media.bibomart.net/file/Banner/4-8-2023-189beae1c33.png" alt="icon"/>
                </p>
                
                <div className="text">
                    <p > Nhắc đến Bibo không thể không nhắc đến các Khoá đào tạo Tiền sản.&nbsp; <br/> Bắt đầu từ năm 2005, đến nay Bibo đã tổ chức thành công hơn 
                    <span >15.000 khoá đào tạo “Nghề làm cha mẹ” miễn phí</span> cho hàng chục triệu Ba Mẹ khắp Việt Nam.&nbsp; </p>
                    <p >Các khoá đào tạo đầu tiên, chị Phương trực tiếp đứng lớp chia sẻ. Các khoá sau này, Bibo hợp tác với tất cả các Bệnh viện Nhi sản lớn nhất cả nước, hàng trăm Bác sỹ và Chuyên gia hàng đầu trong lĩnh vực Chăm sóc sức khoẻ, Giáo dục sớm, Tâm lý... cùng tham gia đào tạo, mỗi lớp hiện đang thu hút hàng trăm học viên tham gia mỗi tuần.</p>
                    <p >Bibo là đơn vị tiên phong định vị <span >“Làm Cha mẹ là một nghề cần phải học".</span> Hầu như Mẹ nào mang thai cũng sẽ đi học Tiền sản ở Bibo Mart. Các ông Bố luôn được mời tham gia cùng Mẹ để đồng cảm và sẻ chia vai trò chăm sóc con với Mẹ. </p>
                    <p >Bền bỉ tổ chức hàng chục ngàn khoá đào tạo, cả offline và trên các kênh trực tuyến cho hàng chục triệu Ba Mẹ suốt 18 năm qua, Bibo đã góp phần lớn xây dựng nên một cộng đồng triệu triệu Ba Mẹ thông thái ở Việt Nam, giúp hàng chục triệu Em bé được nuôi dạy đúng cách, phát triển khoẻ mạnh cả về thể chất và tinh thần.</p>
                </div>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf3c733b.png" alt="icon"/>
                </p>
                <p >15.000 khoá đào tạo miễn phí đã được tổ chức</p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189beb75dce.png" alt="icon"/>
                </p>
                <p >Hợp tác với hàng trăm Bác sỹ và Chuyên gia đầu ngành</p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bebb6e7c.png" alt="icon"/>
                </p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bebc08e2.png" alt="icon"/>
                </p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bebc64a7.png" alt="icon"/>
                </p>
                <p >Hợp tác với tất cả các Bệnh viện Sản Nhi lớn nhất cả nước</p>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bebe3d9c.png" alt="icon"/>
                </p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bebefcfc.png" alt="icon"/>
                </p>
                <p >Liên tục cập nhật chủ đề hữu ích nhất mà các Mẹ quan tâm</p>
                <div></div>
                <div >
                    <div className="text"> CUNG CẤP GIẢI PHÁP CHĂM SÓC MẸ BÉ <br/> CHUẨN CHUYÊN GIA! </div>
                </div>
                <div ></div>
                <div className="text">
                    <p >Đến với Bibo, các Ba Mẹ không chỉ được cung cấp sản phẩm mà còn nhận được sự tư vấn và hướng dẫn “chuẩn chuyên gia" từ đội ngũ nhân sự được đào tạo bài bản của Bibo.</p>
                    <p > Ở Bibo, trong hàng ngàn nhân viên, <span > hơn 40% được tuyển là sinh viên tốt nghiệp các trường y tế hệ Bác sỹ, Y tá, Điều dưỡng, Nữ hộ sinh</span> ... được đào tạo chuyên khoa chăm sóc sức khoẻ Mẹ &amp; Bé.&nbsp; <br/>
                    </p>
                    <p > Ngoài ra. 100% nhân sự phải tham gia khoá đào tạo 30 tuần gồm 10 Chuyên đề về Chăm sóc Mẹ Bầu và Em bé theo từng giai đoạn. Chỉ những nhân sự thi tốt nghiệp và được cấp chứng chỉ Chuyên viên Tư vấn mới được phục vụ Khách hàng. </p>
                </div>
                <div ></div>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bec97e4d.png" alt="icon"/>
                </p>
                <p > Trung tâm đào tạo nội bộ <br/> Do các Bác sỹ fulltime phụ trách đào tạo </p>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf2e2597.png" alt="icon"/>
                </p>
                <p > 100% nhân sự phải qua đào tạo chăm sóc <br/> sức khoẻ Mẹ Bé và thi cấp chứng chỉ </p>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf2f56f6.png" alt="icon"/>
                </p>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf2fe386.png" alt="icon"/>
                </p>
                <p > Phòng Chuyên gia với các Bác sỹ làm việc <br/> toàn thời gian thường trực hỗ trợ Ba Mẹ </p>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bee328a9.png" alt="icon"/>
                </p>
                <div ></div>
                <div className="text">
                    <p > Bibo là đơn vị <span >khai sinh ra mô hình bán lẻ “One-Stop-Shop" dành cho Mẹ&amp;Bé ở Việt Nam.</span>
                     Nơi Ba Mẹ có thể đến một nơi và mua được mọi thứ Bé cần, với hơn 30.000 sản phẩm từ hơn 800 Nhà cung cấp hàng đầu trên thế giới.&nbsp; <br/>
                      100% sản phẩm chính hãng, có chứng nhận an toàn, có hoá đơn đầy đủ... mang lại sự an tâm tuyệt đối cho Ba Mẹ khi mua sắm. </p>
                </div>
                
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf314ec4.png" alt="icon"/>
                </p>
                <p >
                    <strong>200</strong> siêu thị, <strong>33</strong> tỉnh thành, hàng chục triệu lượt khách mỗi năm.
                </p>
                <div ></div>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf32eca0.png" alt="icon"/>
                </p>
                <div ></div>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf34719f.png" alt="icon"/>
                </p>
                <div ></div>
                <div >
                    <p className="text"> HÃY ĐỂ BIBO ĐỒNG HÀNH CÙNG BA MẸ TRÊN HÀNH TRÌNH LÀM CHA MẸ THIÊNG LIÊNG NÀY, BA MẸ NHÉ! </p>
                </div>
                <div ></div>
                <p >
                    <img  src="https://media.bibomart.net/file/Banner/4-8-2023-189bf35d219.png" alt="icon"/>
                </p>
                <div ></div>
                <p >
                    <span >CÔNG TY CỔ PHẦN BIBOMART TM</span>
                    <br/>
                    <span> 120 Trần Duy Hưng, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam <br/> Hotline: (024) 73091168 <br/> Email: cskh@bibomart.com.vn 
                    <br/> Website: https://bibomart.com.vn/ </span>
                </p>
                <div ></div>
                </div>
    )
}
export default About;